import React from 'react';
import { motion } from 'framer-motion';
import './RACHowItWorks.css';

const RACHowItWorks = () => {
  console.log('[RACHowItWorks] Component rendered');
  
  const steps = [
    {
      number: '1',
      title: 'Choose Your Tier',
      description: 'Select ₹2.5L (1 animal), ₹5L (2 animals), or ₹10L (4 animals) and complete onboarding/KYC.'
    },
    {
      number: '2',
      title: 'Animal Mapping & Identification',
      description: 'Animals are mapped 1 owner : 1 animal. You receive the animal\'s ID (RFID/tag), breed, age, and health/lactation status.'
    },
    {
      number: '3',
      title: 'Asset Purchase Documentation',
      description: 'Ownership certificate and animal ID record are issued in your name for the mapped animal(s).'
    },
    {
      number: '4',
      title: 'Execute the Hire-back Agreement & Payment Schedule (Hire Rent)',
      description: 'Defines Active Lease Days, planned dry period cap, suspension events, replacement process, hire rent payout schedule, cure/default remedies, buyback terms.'
    },
    {
      number: '5',
      title: 'Managed Operations by PharmWealth',
      description: 'Feeding, healthcare, breeding, and farm operations managed by PharmWealth.'
    },
    {
      number: '6',
      title: 'Monthly Hire Rent Payout + Logs',
      description: 'Bank transfer on the 10th day of each month for the prior month, with monthly statements and daily logs/records. Monthly hire rent payout is prorated by Active Lease Days.'
    }
  ];
  
  return (
    <section className="rac-how-it-works">
      <div className="rac-how-it-works-container">
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="rac-section-title"
        >
          How RAC Works
        </motion.h2>
        <div className="rac-gold-line"></div>
        <div className="rac-steps-grid">
          {steps.map((step, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.5 + index * 0.1 }}
              className="rac-step-card"
            >
              <div className="rac-step-number">{step.number}</div>
              <h3 className="rac-step-title">{step.title}</h3>
              <p className="rac-step-description">{step.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default RACHowItWorks;


